import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { ProfileBento } from "../components/ProfileBento";
import { Explainer, Manifesto } from "../components/Sections";
import { Process } from "../components/Process";
import { FAQ } from "../components/FAQ";
import { Contact } from "../components/Contact";

const HOME_FAQ = [
  { q: "Vocês trabalham com quais tipos de caso?", a: "Atuamos na negociação com bancos e na defesa de quem sofre busca e apreensão de veículos, máquinas agrícolas e outros bens em alienação fiduciária, além de execuções de título extrajudicial e ações monitórias." },
  { q: "Atendem o agronegócio?", a: "Sim. Temos uma frente dedicada a produtores rurais, que podem enfrentar ao mesmo tempo busca e apreensão de maquinário, execuções e ações monitórias." },
  { q: "Como funciona o primeiro contato?", a: "Você chama no WhatsApp ou preenche o formulário. Pedimos os documentos principais (contrato, notificação ou processo) para fazer uma análise inicial da situação." },
  { q: "Atendem fora do Rio de Janeiro?", a: "Estamos no Rio de Janeiro e o atendimento pode ser realizado de forma remota. Fale conosco para avaliarmos o seu caso." },
  { q: "Vocês garantem que vou ficar com o bem?", a: "Nenhum resultado pode ser garantido de antemão. O que garantimos é uma análise séria, uma estratégia clara e dedicação em cada etapa da negociação e da defesa." },
];

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <ProfileBento />
      <Explainer />
      <Manifesto />
      <Process />
      <FAQ items={HOME_FAQ} />
      <Contact />
    </main>
  );
}
